document.addEventListener('DOMContentLoaded', () => {
    let jdgmCarouselItems = document.querySelectorAll('#shopify-block-AMzBjZVgvLzBkbkxxL__judge_me_reviews_featured_carousel_NaghnU .jdgm-widget.jdgm-carousel .jdgm-carousel-item ');
    let slidesWrapper = document.querySelector('.vc-reviews-slider');

    function truncateString(str, maxLength) {
        if (str.length > maxLength) {
            return str.slice(0, maxLength - 3) + '...'; // Truncate and add '...'
        }
        return str; // Return original string if within limit
    }
  
    if(jdgmCarouselItems.length > 0) {
      let counter = 0;
      jdgmCarouselItems.forEach(item => {
        counter ++;
        let stars = item.querySelector('.jdgm-carousel-item__review-rating').getAttribute("aria-label")
        let img = item.querySelector('.jdgm-carousel-item__product-image').getAttribute("data-src")
        let url = item.querySelector('.jdgm-carousel-item__product').getAttribute("href")
        let productName = item.querySelector('.jdgm-carousel-item__product-title').textContent
        let reviewTitle = item.querySelector('.jdgm-carousel-item__review-title').textContent
        let reviewCopy = item.querySelector('.jdgm-carousel-item__review-body p').textContent
        let authorName = item.querySelector('.jdgm-carousel-item__reviewer-name').textContent

        var truncatedReviewTitle = truncateString(reviewTitle, 25);
        // reviewCopy = truncateString(reviewCopy, 200);

        const maxReviewCopyLength = 120;
            const truncatedReviewCopy = reviewCopy.length > maxReviewCopyLength ? 
                reviewCopy.slice(0, maxReviewCopyLength - 9) + '...' + '<a href="#" class="see-more rev-sm">see more</a>' : 
                reviewCopy;
        
        var slide = `
        
        <div class="review-slide">
          <div class="review-slide-inner">
            <a href="${url}">
              <img src="${img}" loading='lazy' width="200" height="200" alt="${productName}">
              <span>${productName}</span>
            </a>
            <div class="star">
              <span class="jdgm-star jdgm--on"></span>
              <span class="jdgm-star jdgm--on"></span>
              <span class="jdgm-star jdgm--on"></span>
              <span class="jdgm-star jdgm--on"></span>
              <span class="jdgm-star jdgm--on"></span>

            </div>
            <div class="review-body">
              <svg width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.77265 14.7729L5.04331 14.7553C-2.94541 14.6144 -0.282508 2.42584 8.26594 5.64912C14.5755 8.02695 13.4052 18.965 6.65462 20.7616C3.66945 21.5542 0.345061 20.9905 2.82139 20.1099C4.94154 19.3701 6.65462 17.2388 6.5359 15.4951C6.50197 15.1076 6.17971 14.7729 5.77265 14.7729Z" fill="#CCCCCC"/>
                <path d="M21.3602 5.20875C29.0436 8.2735 25.9227 21.6598 17.3912 22.2411C15.1693 22.3996 14.5927 21.8536 16.2718 21.2019C17.9001 20.5678 19.9524 17.5735 20.1729 15.5479C20.2238 15.1428 19.9185 14.8081 19.5284 14.8081C17.2895 14.8081 16.3566 14.8081 15.0506 12.9411C11.8449 8.32635 16.1022 3.11274 21.3602 5.20875Z" fill="#CCCCCC"/>
              </svg>
              <strong class="review-title">${truncatedReviewTitle}</strong>
              <p class="review-copy">${ truncatedReviewCopy }</p>
            </div>
            <p class="reviewer">
              <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.592 5.99985C11.592 8.98219 9.17433 11.3999 6.19199 11.3999C3.20965 11.3999 0.791992 8.98219 0.791992 5.99985C0.791992 3.01752 3.20965 0.599854 6.19199 0.599854C7.03922 0.599854 7.84088 0.794967 8.55449 1.14271M10.5795 2.62485L5.85449 7.34985L4.50449 5.99985" stroke="#84BE43" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              ${authorName}
            </p>
          </div>
        </div>
        `
        slidesWrapper.innerHTML += slide

        // Store full review details in data attributes for later use
            const lastSlide = slidesWrapper.children[slidesWrapper.children.length - 1];
            const seeMoreLink = lastSlide.querySelector('.see-more');
            
            if (seeMoreLink) {
                seeMoreLink.setAttribute('data-review-title', reviewTitle);
                seeMoreLink.setAttribute('data-full-review', reviewCopy);
                seeMoreLink.setAttribute('data-product-image', img);
                seeMoreLink.setAttribute('data-product-name', productName);
                seeMoreLink.setAttribute('data-product-url', url);
                seeMoreLink.setAttribute('data-author-name', authorName);
            }

        
        // console.log({
         
        //   reviewTitle,
        //   reviewCopy
        // })
      });
      if (counter == 15) {
        console.log('hook the sliders')
        var elem = document.querySelector('.vc-reviews-slider');
        var flkty = new Flickity( elem, {
          freeScroll: true,
          wrapAround: true,
          contain: true,
          cellAlign: 'left',
          autoPlay: 2500,
          pauseAutoPlayOnHover: true,
          selectedAttraction: 0.01,
          friction: 0.15,
          // groupCells: 2,
          prevNextButtons: false
        });
        
      }

       // Event listener for 'See more' links
        // Inside your event listener for 'See more'
          slidesWrapper.addEventListener('click', function(event) {
              if (event.target.classList.contains('see-more')) {
                  event.preventDefault();
          
                  // Get all the full review details from data attributes
                  const fullReviewCopy = event.target.getAttribute('data-full-review');
                  const fullReviewTitle = event.target.getAttribute('data-review-title');
                  const productImage = event.target.getAttribute('data-product-image');
                  const productName = event.target.getAttribute('data-product-name');
                  const productUrl = event.target.getAttribute('data-product-url');
                  const authorName = event.target.getAttribute('data-author-name');
          
                  // Populate modal with details
                  document.getElementById('modal-product-image').src = productImage;
                  document.getElementById('modal-product-title').textContent = productName;
                  document.getElementById('modal-review-title').textContent = fullReviewTitle; // Use title from context
                  document.getElementById('modal-review-copy').textContent = fullReviewCopy; // Use full review copy
                  document.getElementById('modal-author-name').textContent = authorName;
                  document.getElementById('modal-product-link').href = productUrl; // Set product link
          
                  // Show the modal
                  document.getElementById('review-modal').style.display = 'block';
              }
          });


        // Close modal functionality
        document.querySelector('.close-button').addEventListener('click', function() {
            document.getElementById('review-modal').style.display = 'none';
        });

        // Close modal when clicking outside of it
        window.addEventListener('click', function(event) {
            const modal = document.getElementById('review-modal');
            if (event.target === modal) {
                modal.style.display = 'none';
            }
        });
      
      
    }else {
      console.log("didn't work")
    }
  });

// document.addEventListener('DOMContentLoaded', () => {
  //   let jdgmCarouselItems = document.querySelectorAll('.js-jdgm-carousel[data-id="template--15361201307881__1636396338af5b800c"] .jdgm-rev-widg__reviews > .jdgm-rev ');
  //   let slidesWrapper = document.querySelector('.js-glide-jdgm-carousel[data-id="template--15361201307881__1636396338af5b800c"] .glide__slides');

  //   if(jdgmCarouselItems.length > 0) {
  //     jdgmCarouselItems.forEach(item => {
  //       let stars = item.querySelector('.jdgm-rev__rating').getAttribute("data-score")
  //       let authoreName = item.querySelector('.jdgm-rev__author').textContent
        
  //       let newSlide = document.createElement('LI');
  //       let authorEl = document.createElement('p');
  //       authorEl.innerHTML = authoreName
  //       newSlide.classList.add('glide__slide');
  //       newSlide.innerHTML = `<span class="quote-mark"> <svg width="60" height="53" viewBox="0 0 60 53" fill="none" xmlns="http://www.w3.org/2000/svg"> <g id="left-quote"> <path id="Path" d="M24.2873 10.5239C25.7992 9.89355 26.4332 8.09947 25.7504 6.6448L23.3607 1.65047C22.6779 0.244781 21.0197 -0.386057 19.5566 0.244781C15.4112 1.99037 11.851 4.26934 9.02239 7.0332C5.55974 10.2815 3.2188 14.0151 1.95079 18.1366C0.682775 22.3071 0 27.9798 0 35.2046V50.0907C0 51.6908 1.31678 53 2.92618 53H22.0927C23.7021 53 25.0188 51.6908 25.0188 50.0907V31.0346C25.0188 29.434 23.7021 28.1253 22.0927 28.1253H12.924C13.0215 23.2275 14.192 19.3004 16.3378 16.3421C18.0935 13.9671 20.7271 12.0275 24.2873 10.5239Z" fill="#313376"/> <path id="Path_2" d="M58.2601 10.4847C59.7748 9.85381 60.4095 8.05809 59.726 6.60211L57.3317 1.65224C56.6477 0.244787 54.9864 -0.38614 53.5205 0.244787C49.4162 1.99197 45.8976 4.27301 43.0153 6.99085C39.5456 10.2911 37.1519 14.0281 35.881 18.1534C34.6106 22.2297 33.9759 27.9085 33.9759 35.1884V50.088C33.9759 51.6896 35.2952 53 36.9076 53H56.1102C57.7226 53 59.0419 51.6896 59.0419 50.088V31.0146C59.0419 29.4125 57.7226 28.1026 56.1102 28.1026H46.8754C46.9731 23.2003 48.1463 19.2697 50.2957 16.3087C52.0547 13.9311 54.6932 11.9897 58.2601 10.4847Z" fill="#313376"/></g></svg></span>`;
  //       if(stars == 5){
  //         newSlide.appendChild(item);
  //         newSlide.appendChild(authorEl);
  //         slidesWrapper.appendChild(newSlide);
  //       }else{
  //         return
  //       }
  //     });

  //     let jdgmGlide = new Glide('.js-glide-jdgm-carousel', {
  //       type: 'carousel',
  //       perView: 2,
  //       autoplay: 5000,
  //       gap: 30,
  //       breakpoints: {
  //         480: {
  //           perView: 1
  //         }
  //       }
  //     });
  //     jdgmGlide.mount();
  //   }else {
  //     document.querySelector(".product-rev-car").style.display = 'none'
  //   }
  // });
